var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShield2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-ca_rd",
    "data-name": "icon-ca rd",
    transform: "translate(-240 -3397)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    width: 80,
    height: 80,
    transform: "translate(240 3397)",
    fill: "#02fdea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-shield-check",
    transform: "translate(220.667 3417.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67436",
    "data-name": "Group 67436",
    transform: "translate(42.667 -0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67435",
    "data-name": "Group 67435",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80494",
    "data-name": "Path 80494",
    d: "M70.3,3.562,59.86.08a1.667,1.667,0,0,0-1.053,0L48.365,3.562a8.322,8.322,0,0,0-5.7,7.9v8.528c0,12.6,15.333,19.566,15.99,19.856a1.667,1.667,0,0,0,1.353,0C60.666,39.561,76,32.6,76,19.995V11.467a8.322,8.322,0,0,0-5.7-7.9Zm2.365,16.433c0,9.092-10.532,15.055-13.333,16.481C56.528,35.055,46,29.11,46,19.995V11.467a5,5,0,0,1,3.42-4.743l9.914-3.305,9.913,3.3a5,5,0,0,1,3.42,4.743Z",
    transform: "translate(-42.667 0.005)",
    fill: "#12784a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80495",
    "data-name": "Path 80495",
    d: "M165.724,171.3l-6.98,7L155,174.4a1.667,1.667,0,1,0-2.4,2.31l3.843,4a3.12,3.12,0,0,0,2.242,1h.055a3.122,3.122,0,0,0,2.225-.922l7.12-7.12a1.673,1.673,0,1,0-2.363-2.368Z",
    transform: "translate(-143.558 -157.466)",
    fill: "#12784a"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield2);
export default __webpack_public_path__ + "static/media/shield2.e6616ee3e91c37a300295c6a8a1ea98c.svg";
export { ForwardRef as ReactComponent };